import { useCallback } from "react";

import { useFetchUserPledges } from "CrossFeatureComponents/UserPledgesList/useFetchUserPledges";
import { useFetchUserRecurringGifts } from "CrossFeatureComponents/UserRecurringGifts/useFetchUserRecurringGifts";
import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import Fetch from "./API/fetch";

function getToday() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function getOneYearAgo() {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 1);
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function useFetchUserPledgeAndGivingData() {
  // This fetches all the other user giving data we need:
  // - user giving
  // - user pledges
  // - user recurring gifts

  const {
    state: { userID },
    dispatch,
  } = useManageMyGivingPage();

  const fetchUserPledges = useFetchUserPledges();
  const fetchUserRecurringGifts = useFetchUserRecurringGifts();

  return useCallback(() => {
    fetchUserPledges(userID);
    fetchUserRecurringGifts(userID);

    const postData = {
      startDate: getOneYearAgo(),
      endDate: getToday(),
    };

    dispatch({ type: "setUserGivingDataStatus", payload: "loading" });
    Fetch.getProfileGivingData({ userID, postData })
      .post()
      .then(({ data }) => {
        dispatch({
          type: "setUserGivingData",
          payload: data,
        });
        dispatch({ type: "setUserGivingDataStatus", payload: "success" });
      })
      .catch((err) => {
        dispatch({ type: "setUserGivingDataStatus", payload: "error" });
      });
  }, [userID, fetchUserPledges, fetchUserRecurringGifts, dispatch]);
}
